import React from 'react';

const uil = () => {
    return (
        <div>
            <svg
                className="logo logo0"
                id='this'
                width="500.000000pt"
                height="368.000000pt"
                viewBox="0 0 500.000000 368.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,368.000000) scale(0.100000,-0.100000)"
                  stroke="none"
                >
                  <path
                    d="M2651 3603 c-12 -37 -54 -169 -95 -293 l-73 -225 -339 -5 -338 -5
265 -189 c145 -104 267 -192 271 -195 5 -4 -37 -141 -92 -306 -55 -164 -99
-300 -97 -301 1 -1 31 19 67 45 36 26 152 110 259 185 l194 138 71 -49 c39
-27 158 -111 265 -186 106 -76 195 -137 196 -135 2 2 -39 134 -91 293 -51 160
-94 296 -94 303 0 6 116 99 257 205 l257 192 -321 5 c-195 3 -326 9 -332 15
-5 6 -53 136 -106 290 -53 154 -98 282 -100 283 -2 2 -13 -27 -24 -65z"
                  />
                  <path
                    d="M1154 2925 c-2 -5 -3 -284 -2 -620 l3 -610 51 3 c46 3 54 0 73 -24
17 -21 24 -24 35 -15 16 13 103 2 173 -22 39 -13 42 -13 50 7 8 17 20 21 68
22 48 2 69 -4 124 -32 36 -19 78 -34 92 -34 25 0 28 -4 33 -47 4 -27 6 -79 6
-117 -1 -71 30 -171 57 -189 7 -4 13 -21 13 -36 0 -15 5 -42 11 -60 9 -26 9
-34 -4 -44 -8 -7 -18 -32 -21 -57 -11 -97 -14 -103 -84 -148 -62 -40 -67 -42
-70 -23 -4 24 -22 29 -22 5 0 -17 -50 -84 -63 -84 -5 0 -29 -18 -54 -40 -44
-38 -103 -55 -103 -30 0 6 -16 0 -36 -14 -45 -30 -73 -90 -80 -170 -3 -34 -10
-73 -15 -87 -8 -20 -5 -40 10 -85 12 -32 21 -59 21 -60 0 -10 -64 -13 -75 -4
-8 6 -24 11 -37 9 -13 -1 -40 6 -60 15 -21 9 -42 16 -49 16 -6 0 -24 11 -41
25 -16 14 -36 25 -45 25 -11 0 -14 7 -10 23 8 27 -2 44 -28 48 -17 4 -20 13
-21 52 0 34 -7 54 -22 70 -12 13 -22 29 -22 35 0 18 -30 62 -43 62 -14 0 -36
32 -37 53 0 9 -16 40 -35 68 -19 28 -35 56 -35 63 0 6 -17 25 -38 43 -37 30
-42 31 -115 29 -42 -1 -78 -4 -81 -7 -2 -2 -13 -23 -25 -46 -27 -55 -55 -70
-84 -48 -12 8 -37 25 -55 36 -17 12 -32 24 -32 28 0 4 -20 20 -44 35 -51 32
-57 42 -62 110 -4 53 -26 86 -56 86 -10 0 -18 5 -18 11 0 18 -100 129 -116
129 -8 0 -14 8 -14 18 0 10 -7 27 -15 38 -33 43 -29 44 243 44 l259 0 6 107
c4 58 7 179 7 268 0 89 3 196 6 238 l7 77 129 0 128 0 -2 428 -3 427 -442 3
-443 2 1 -792 c0 -436 4 -962 9 -1168 7 -346 9 -380 30 -445 39 -124 121 -252
198 -308 94 -69 294 -150 462 -188 172 -39 587 -35 760 7 212 52 430 221 499
389 18 42 41 116 51 163 19 83 20 138 19 1112 l0 1025 -142 100 -142 100 -294
5 c-191 3 -295 2 -297 -5z"
                  />
                  <path
                    d="M3458 2832 l-138 -107 0 -1347 0 -1348 840 0 840 0 0 455 0 455 -345
0 -345 0 0 1000 0 1000 -357 -1 -358 -1 -137 -106z"
                  />
                  <path
                    d="M2425 2052 c-132 -98 -239 -181 -237 -185 1 -4 2 -421 2 -927 l0
-920 493 2 492 3 3 175 c2 96 0 514 -3 927 l-7 753 -97 68 c-180 128 -400 282
-403 282 -2 0 -111 -80 -243 -178z"
                  />
                </g>
              </svg>
        </div>
    );
};

export default uil;


// WEBPACK FOOTER //
// ./src/Components/Footer/uil.js